import { Col, Row, Card } from 'reactstrap'
import { IconArrowRight } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import { CardTooltip } from '../_molecules/_index'
import styled from 'styled-components'
import { Avatar } from 'dsm-react-lib'
import { useSasToken } from '../../_hooks/useSasToken'

export const CategoryDescription = styled.div`
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 21px;
  text-align: left;
  vertical-align: top;
  opacity: 50%;
  color: var(--text-heading);
  font-weight: 400;
`

export const CategoryCardWrapper = styled(Card)`
  height: 165px;
`

const CategoryCard = ({ item }) => {
  const { appendToken } = useSasToken()
  if (item === null || item === undefined || Object.keys(item).length === 0) {
    return null
  }

  const mapper = {
    name: item.category.name,
    icon: item.category.icon.url,
    description: item.category.description,
    count: item.applicationsCount,
    apps: item.categoryApplications,
    uniqueName: item.category.uniqueName
  }
  const maxCount = 4

  return (
    <CategoryCardWrapper className="shadow-sm" data-testid={`categoryCard-${item.category.name}`}>
      <Row className="p-2 mb-3 w-100">
        <Col md={12}>
          <div className="d-flex justify-content-end">
            <div className="flex-fill ps-1">
              <h4 className="heading-cart-sm ps-1">
                <Link
                  to={`/categories/view/${mapper.uniqueName}`}
                  className="theme-text-heading hover-dark-link"
                  data-testid={`categoryApps-${mapper.uniqueName}`}>
                  {mapper.name}
                </Link>
                <span className="d-inline text-muted font-weight-light ps-1">
                  {mapper.count} {mapper.count > 1 ? 'Apps' : 'App'}
                </span>
              </h4>
            </div>
            <div className="ms-auto px-1">
              <Link to={`/categories/view/${mapper.uniqueName}`} className="theme-text-heading">
                <IconArrowRight size={23} />
              </Link>
            </div>
          </div>
        </Col>
        <Col md={12}>
          <div className="d-flex flex-fill ps-1 pb-1">
            <CategoryDescription className="ps-1">{mapper.description}</CategoryDescription>
          </div>
        </Col>
        <Col md={12} className="mr-1 mb-1 ps-1">
          <div className="d-flex ps-1">
            {mapper &&
              mapper.apps.slice(0, 4).map((item, index) => (
                <div key={index}>
                  <Link
                    to={{
                      pathname: `/apps/${item.uniqueName}`,
                      state: {
                        from: 'Categories',
                        name: `${mapper.name}`,
                        id: `${mapper.uniqueName}`
                      }
                    }}
                    className="theme-text-heading"
                    data-testid={`categoryCard-${item.uniqueName}`}>
                    <div className="p-0">
                      <Avatar
                        content={appendToken(item.applicationIcon)}
                        shape="rounded"
                        size="54px"
                        data-tooltip-id={`category-card-${item.uniqueName}`}
                      />
                    </div>
                  </Link>
                  <CardTooltip id={`category-card-${item.uniqueName}`} item={item} />
                </div>
              ))}
            <div className="mt-1 ms-1">
              <h4 className="apps-in-category d-flex">
                <span>
                  {mapper.count > maxCount &&
                    `+`
                      .concat(mapper.count - maxCount)
                      .concat(mapper.count === maxCount + 1 ? ' App' : ' Apps')}
                </span>
                <span className="cp-0-5"></span>
              </h4>
            </div>
          </div>
        </Col>
      </Row>
    </CategoryCardWrapper>
  )
}
export default CategoryCard
